export default __webpack_public_path__ + "f56343eacff65b6b718f15e979fcee46.svg";